import React from "react";
import { Route } from "react-router-dom";
import Settings from "../components/Settings";

export default [<Route path="/app_settings" component={Settings} />];
